import { api } from '../config'

export const CONTROL_URL = {
  getControl: `${api.withAPI}/admin/app-config/current`,
  updateControl: `${api.withAPI}/admin/app-config`,
  updateRegion: `${api.withAPI}/admin/app-config/region-permissions`,
  updateDefaultPermissions: `${api.withAPI}/admin/app-config/default-region-permissions`,
}
